<template>
  <div>
    <div class="top1"></div>
    <div class="top">
      <div class="inner1" style="position: relative">
        <div class="menu" @click="drawer = !drawer">
          <div
            :class="
              drawer == false
                ? 'menuicon el-icon-s-unfold'
                : 'menuicon el-icon-s-fold'
            "
          ></div>
        </div>
        <div class="logo">
          <a>
            <img src="../assets/img/zl_logo.png" alt="" />
          </a>
        </div>
        <div class="indextext">
          <img src="../assets/img/首页字体.png" alt="" />
        </div>
        <div
          class="ggh"
          @mouseenter.stop="show3 = true"
          @mouseleave.stop="show3 = false"
        >
          <img src="../assets/img/zl_wx.png" alt="" />
          <span>微信公众号</span>
          <el-collapse-transition v-if="show3">
            <div class="gghimg">
              <img src="../assets/img/gzh.png" alt="" />
            </div>
          </el-collapse-transition>
        </div>
        <!-- <div class="sswarp">
          <input type="search" class="inp" />
          <div class="ss">搜索</div>
        </div> -->
      </div>
    </div>
    <div class="toptab aaa">
      <div class="inner1">
        <div class="nav">
          <div class="nav-a">
            <ul class="nav-a-ul">
              <li
                class="nav-a-li"
                :class="classA == index ? 'active' : ''"
                @click="selected(index)"
                v-for="(item, index) in configNav"
                :key="index"
              >
                <div class="x" v-if="index != configNav.length - 1"></div>
                <router-link
                  :to="item.path"
                  class="nav-a-text"
                  :class="classA == index ? 'active-col' : ''"
                  @click="showToggle(index)"
                  >{{ item.name }}</router-link
                >
                <ul class="menu_ul" :class="{ isShow }">
                  <div class="sj" v-if="item.subItems"></div>
                  <li
                    class="menu_li"
                    v-for="(nav, idx) in item.subItems"
                    :key="idx"
                    :class="classB == nav ? 'active' : ''"
                    @click="menuselected(nav, idx)"
                  >
                    <router-link
                      class="menu_ul_text"
                      :to="nav.link"
                      :class="{ active: nav.link == linkClick }"
                      @click="treeNavSwitch(nav)"
                      >{{ nav.text }}</router-link
                    >
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="mid">
      <router-view></router-view>
    </div>
    <div class="bottom">
      <div class="inner">
        <div class="leftwarp">
          <div class="title">友情链接</div>
          <div class="ljwarp">
            <div class="textlist">
              <span
                ><a href="https://www.mot.gov.cn/" target="blank"
                  >交通运输部</a
                ></span
              >
            </div>
            <div class="textlist">
              <span><a href="https://www.mohurd.gov.cn/">住建部</a></span>
            </div>
            <div class="textlist">
              <span
                ><a href="https://www.ndrc.gov.cn/" target="blank"
                  >国家发改委</a
                ></span
              >
            </div>
            <div class="textlist">
              <span
                ><a href="http://jtyst.shaanxi.gov.cn/" target="blank"
                  >陕西交通厅</a
                ></span
              >
            </div>
            <div class="textlist">
              <span
                ><a href="https://jtt.xizang.gov.cn/" target="blank"
                  >西藏交通厅</a
                ></span
              >
            </div>
            <div class="textlist">
              <span
                ><a href="http://jtyst.xinjiang.gov.cn/" target="blank"
                  >新疆交通厅</a
                ></span
              >
            </div>
            <div class="textlist">
              <span
                ><a href="http://jtt.shandong.gov.cn/" target="blank"
                  >山东交通运输厅</a
                ></span
              >
            </div>
            <div class="textlist">
              <span
                ><a href="https://js.shaanxi.gov.cn/" target="blank"
                  >陕西建设厅</a
                ></span
              >
            </div>
            <div class="textlist">
              <span
                ><a href="http://zjt.xizang.gov.cn/" target="blank"
                  >西藏建设厅</a
                ></span
              >
            </div>
            <div class="textlist">
              <span
                ><a href="http://zjt.xinjiang.gov.cn/" target="blank"
                  >新疆建设厅</a
                ></span
              >
            </div>
          </div>
        </div>
        <div class="rightwarp">
          <div class="title">联系我们</div>
          <div class="xxwarp">
            <div class="xxlist">地址:陕西省西安市灞桥区浐灞商务中心二期</div>
            <div class="xxlist">邮编:710000</div>
            <div class="xxlist">传真:029-83502500</div>
            <div class="xxlist">邮箱:sdguixue@126.com</div>
          </div>
        </div>
      </div>
    </div>
    <div class="security">
      <div class="inner">
        <div class="btlist">
          <div class="bq">
            <a href="http://www.zhonglinn.com/sitemap.xml"> 网站地图 </a>
          </div>
          <div class="bq">安全隐私</div>
          <div class="bq">版权声明</div>
        </div>
        <div class="btlist">
          Copyright © 2011-2019 ZHONGLIN GROUP. 中霖集团 版权所有<a
            href="http://www.eyoucms.com/plus/powerby.php"
            target="_blank"
            >Powered by EyouCms</a
          >　<a href="https://beian.miit.gov.cn/" rel="nofollow" target="_blank"
            >陕ICP备18018627号-1</a
          >
        </div>
        <div class="btlist">网站维护单位：鼎邦科技 电话：029-89613894</div>
      </div>
    </div>
    <div class="appcd">
      <el-drawer
        class="tk"
        :with-header="false"
        :visible.sync="drawer"
        :direction="direction"
        :show-close="false"
        size="60%"
      >
        <div class="menuwarp">
          <div
            :class="index == appaction ? 'menuitem actionitem' : 'menuitem'"
            v-for="(item, index) in configNav"
            :key="index"
            @click="gopages(item, index)"
          >
            <div class="text">{{ item.name }}</div>
            <div class="icon el-icon-arrow-right"></div>
          </div>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      classA: JSON.parse(localStorage.getItem("LayTab")) || 0,
      // classA:  0,
      classB: 0,
      isShow: 0,
      linkClick: "",
      show3: false,
      drawer: false,
      direction: "ltr",
      configNav: [],
      // 123
      tabactions: 0,
      appaction: 0,
    };
  },

  mounted() {
    this.getconfigNavSData(); //获得数据列表
  },
  created() {
    if (this.$route.path == "/home/index") {
      this.classA = 0;
    }
  },
  methods: {
    getType() {
      let Obj = {
        code: "TuWenType",
        state: true,
        sort: "publishTime desc",
        pageIndex: 1,
        pageSize: 4,
      };
      this.$http
        .get("api/Para_DictionaryNod/GetAllTreeData", { params: Obj })
        .then((res) => {
          if (res.status) {
            console.log(res);
            let List = [];
            res.result.forEach((item, index) => {
              var Obj = {
                subItems: [],
              };
              Obj.name = item.title;
              if (item.title === "中霖设计") {
                Obj.path = "/home/ZlDesign/Detail/0";
              } else if (item.title === "装备制造") {
                Obj.path = "/home/EquManu/Detail/0";
              } else if (item.title === "区域基地") {
                Obj.path = "/home/AspTec/detail/0";
              } else if (item.title === "信息智能") {
                Obj.path = "/home/InfTec";
              }
              item.children.forEach((i, idx) => {
                let obj = {};
                if (item.title === "中霖设计") {
                  obj.text = i.title;
                  obj.link = "/home/ZlDesign/Detail/" + idx;
                } else if (item.title === "装备制造") {
                  obj.text = i.title;
                  obj.link = "/home/EquManu/Detail/" + idx;
                } else if (item.title === "区域基地") {
                  obj.text = i.title;
                  obj.link = "/home/AspTec/detail/" + idx;
                } else if (item.title === "信息智能") {
                  obj.text = i.title;
                  obj.link = "/home/InfTec";
                }
                Obj.subItems.push(obj);
              });
              List.push(Obj);
              console.log(List);
              console.log(Obj);
              
            });
            List.forEach((ite) => {
              if (ite.subItems.length===0) {
                delete ite.subItems;
              }
            });
            let configNav = this.configNav;
            configNav.push(...List);
            this.configNav = configNav;
            this.configNav.push({
              name: "联系我们",
              path: "/home/ContactUs",
            });
          }
        });
    },
    getEquManu() {
      let Obj = {
        code: "TuWenType",
        state: true,
        sort: "publishTime desc",
      };
      this.$http
        .get("api/Para_DictionaryNod/GetAllTreeData", { params: Obj })
        .then((res) => {
          console.log(res);
          let Index = 0;
          if (res.status) {
            res.result.forEach((item, index) => {
              if (item.title === "装备制造") {
                Index = index;
              }
            });
            let Obj = res.result[Index];
            let list = res.result[Index].children;
            let subItems = [];
            let subObj = {};
            let firstitempath = "";
            list.forEach((i, index) => {
              firstitempath = "/home/EquManu/Detail/0";
              let item = {
                link: "/home/EquManu/Detail/" + index,
                text: i.title,
              };
              subItems.push(item);
            });
            subObj = {
              name: Obj.title,
              path: firstitempath,
              subItems: subItems,
            };
            this.configNav.push({
              name: Obj.title,
              path: firstitempath,
              subItems: subItems,
            });
          }
        });
    },
    getAspTec() {
      let Obj = {
        code: "TuWenType",
        state: true,
        sort: "publishTime desc",
      };
      this.$http
        .get("api/Para_DictionaryNod/GetAllTreeData", { params: Obj })
        .then((res) => {
          console.log(res);
          let Index = 0;
          if (res.status) {
            res.result.forEach((item, index) => {
              if (item.title === "区域基地") {
                Index = index;
              }
            });
            let Obj = res.result[Index];
            this.configNav.push({
              name: Obj.title,
              path: "/home/AspTec",
            });
          }
        });
    },
    getInfTec() {
      let Obj = {
        code: "TuWenType",
        state: true,
        sort: "publishTime desc",
      };
      this.$http
        .get("api/Para_DictionaryNod/GetAllTreeData", { params: Obj })
        .then((res) => {
          console.log(res);
          let Index = 0;
          if (res.status) {
            res.result.forEach((item, index) => {
              if (item.title === "信息智能") {
                Index = index;
              }
            });
            let Obj = res.result[Index];
            this.configNav.push({
              name: Obj.title,
              path: "/home/InfTec",
            });
            this.configNav.push({
              name: "联系我们",
              path: "/home/ContactUs",
            });
          }
        });
    },

    gopages(res, index) {
      this.$router.push(res.path);
      this.appaction = index;
      this.drawer = false;
      localStorage.setItem("LayTab", JSON.stringify(index));
    },
    selected(index) {
      this.classA = index;
      localStorage.setItem("LayTab", JSON.stringify(index));
    },
    menuselected(nav, index) {
      this.classB = nav;
    },
    showToggle(index) {
      if (index == 5) {
        return;
      } else {
        this.isShow = index;
      }
    },
    treeNavSwitch(nav) {
      this.linkClick = nav.link;
    },
    // 123
    handleSelect(key, keyPath) {},
    changeaction(index) {
      this.tabactions = index;
    },

    getconfigNavSData() {
      this.configNav = [
        {
          name: "首页",
          path: "/",
        },
        {
          name: "集团介绍",
          path: "/home/GroupIntroduction",
          subItems: [
            { link: "/home/GroupIntroduction/index", text: " 公司简介 " },
            { link: "/home/GroupIntroduction/Xgzz", text: " 资质荣誉 " },
            { link: "/home/GroupIntroduction/Qywh", text: " 企业文化 " },
            { link: "/home/GroupIntroduction/Zfgs", text: " 子分公司 " },
          ],
        },
        {
          name: "新闻资讯",
          path: "/home/News",
          subItems: [{ link: "/home/News", text: "公司要闻" }],
        },

        // {
        //   name: "中霖设计",
        //   path: "/home/ZlDesign",
        //   subItems: [
        //     { link: "/home/ZlDesign/Detail/0", text: "业务介绍" },
        //     { link: "/home/ZlDesign/Detail/1", text: "临沂拌合站" },
        //     { link: "/home/ZlDesign/Detail/2", text: "威海拌合站" },
        //   ],
        // },
        // {
        //   name: "装备制造",
        //   path: "/home/News",
        // },
        // {
        //   name: "沥青科技",
        //   path: "/home/News",
        // },
        // {
        //   name: "信息科技",
        //   path: "/home/News",
        // },
        // {
        //   name: "联系我们",
        //   path: "/home/ContactUs",
        // },
      ];
      this.getType();
      // this.getEquManu();
      // this.getAspTec();
      // this.getInfTec();
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 601px) {
  .top {
    width: 100%;
    height: 120px;
    background: url(../assets/img/top_bgs.jpg) no-repeat;
    background-size: cover;
    .inner1 {
      width: 1200px;
      margin: 0 auto;
      height: 120px;
    }
    .menu {
      display: none;
      float: left;
    }
    .gghimg1 {
      // display: none;
      float: right;
      top: 30px;
      right: 30px;
      z-index: 99999 !important;
      width: 100px;
      height: 100px;
      // display: none;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }

    .logo {
      width: 222px;
      height: 66px;
      margin-top: 27px;
      margin-left: 10px;
      float: left;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    .indextext {
      position: absolute;
      left: 455px;
      top: 50px;
      img {
        display: block;
      }
    }
    .sswarp {
      width: 323px;
      height: 37px;
      box-sizing: border-box;
      float: right;
      overflow: hidden;
      margin-top: 41px;
      .inp {
        width: 265px;
        box-sizing: border-box;
        height: 37px;
        float: left;
        border: 1px solid #b6b6b6;
        font-size: 18px;
        padding: 0px 8px;
      }
      .ss {
        float: left;
        width: 58px;
        text-align: center;
        color: #fff;
        background: #263c92;
        float: left;
        height: 37px;
        line-height: 37px;
        cursor: pointer;
      }
      input:focus {
        box-sizing: border-box;
        outline: none;
      }
    }
    .ggh {
      float: right;
      width: 140px;
      height: 57px;
      margin-top: 41px;
      margin-left: 60px;
      margin-right: 20px;
      cursor: pointer;
      position: relative;
      .gghimg {
        // display: none;
        position: absolute;
        top: 30px;
        right: 30px;
        z-index: 99999 !important;
        width: 100px;
        height: 100px;
        // display: none;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      img {
        width: 30px;
        height: 24px;
        margin-top: 6px;
        float: left;
      }
      span {
        float: left;
        font-size: 16px;
        font-weight: 550;
        line-height: 37px;
        margin-left: 10px;
        color: #282828;
      }
    }
    // .ggh:hover .gghimg {
    //   display: block;
    // }
  }
  .toptab {
    display: block !important;
    width: 100%;
    height: 54px;
    background: #263c92;
    .inner1 {
      width: 1200px;
      margin: 0 auto;
    }
    .nav {
      background: #263c92;
      width: 1200px;
      height: 54px;
      margin: 0px auto;
      border-bottom: none;
      line-height: 54px;
    }
    .nav-a {
      cursor: pointer;
    }
    .nav-a-ul {
      list-style: none;
    }
    .nav-a-li {
      display: inline-block;
      height: 54px;
      position: relative;
    }
    .nav-a-text {
      font-size: 18px;
      color: #cccccc;
      padding: 0 40px;
      line-height: 54px;
      display: block;
      margin-right: 1px;
      text-decoration: none;
    }
    .x {
      position: absolute;
      width: 1px;
      height: 24px;
      right: 0px;
      top: 15px;
      background: #8c8b89;
    }

    .menu_ul {
      width: 100%;
      list-style: none;
      background: #fff;
      z-index: 99999;
      position: absolute;
      top: 54px;
      left: 0px;
      padding: 0 15px;
      box-sizing: border-box;
      display: none;
    }
    .sj {
      position: absolute;
      top: 0;
      left: 50%;
      margin-left: -10px;
      width: 0;
      height: 0;
      border-top: 10px solid #13297e;
      border-right: 10px solid transparent;
      border-left: 10px solid transparent;
    }
    .menu_li {
      width: 100%;
      height: 46px;
      line-height: 46px;
      border-bottom: 1px solid #efefef;
      text-align: center;
    }
    .menu_li:hover .menu_ul_text {
      font-weight: 550;
    }
    .menu_ul_text {
      width: 100%;
      display: block;
      font-size: 15px;
      color: #666;
      // letter-spacing: 0;
      line-height: 46px;
      text-decoration: none;
    }
    .active-col {
      color: #fff;
    }
    .nav-a-li:hover {
      background: #13297e;
      color: #fff;
    }
    .nav-a-li:hover .nav-a-text {
      color: #fff;
    }
    .nav-a-li.active {
      background: #13297e;
    }
    .nav-a-li:hover .menu_ul {
      display: block;
    }
    .menu_ul_text:hover {
      color: #273c95;
    }
    .menu_li.active .menu_ul_text {
      font-weight: 550;
      color: #273c95;
    }
  }
  // .toptab .router-link-exact-active {
  //   float: left;
  //   height: 54px;
  //   line-height: 54px;
  //   background: #263c92;
  //   color: #fff !important;
  //   margin: 0;
  //   border: none;
  // }
  .bottom {
    width: 100%;
    background: #241e1e;
    color: #989493;
    padding-bottom: 45px;
    padding-left: 0;
    padding-right: 0;
    .leftwarp {
      width: 750px !important;
      float: left;

      overflow: hidden;
      .title {
        width: 100%;
        color: #d9d9d7;
        font-size: 24px !important;
        margin-top: 15px !important;
        line-height: 90px !important;
      }
      .ljwarp {
        width: 100%;
        overflow: hidden;
        .textlist {
          float: left;
          font-size: 20px !important;
          line-height: 45px !important;
          width: 250px !important ;
          span {
            cursor: pointer;
            a {
              color: #989493;
            }
          }
        }
      }
    }
    .rightwarp {
      float: left !important;
      width: 450px !important;
      .title {
        width: 100%;
        color: #d9d9d7;
        font-size: 24px !important;
        margin-top: 15px !important;
        line-height: 90px !important;
      }
      .xxwarp {
        width: 100%;
        overflow: hidden;
        .xxlist {
          width: 100%;
          cursor: pointer;
          font-size: 20px !important;
          line-height: 45px !important;
        }
      }
    }
  }
  .security {
    width: 100%;
    background: #263c92;
    color: #fff;
    padding: 10px 0 !important;
    .inner {
      text-align: center;
      .btlist {
        // min-width: 51%;
        margin: 0 auto;
        overflow: hidden;
        display: flex;
        justify-content: center;
        line-height: 24px !important;
        .bq {
          padding: 0 30px !important;
          border-right: 1px solid #fff;
          line-height: 16px !important;
          margin-bottom: 8px !important;
          a {
            color: #fff;
          }
        }
        a {
          color: #fff;
        }
        .bq:nth-last-child(1) {
          border: none;
        }
      }
    }
  }
}
.toptab .el-menu--horizontal > .el-menu-item.is-active {
  background: #263c92 !important;
  color: #fff !important;
}
.toptab .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  background: #263c92 !important;
  color: #fff !important;
}
@media (min-width: 0px) and (max-width: 600px) {
  .top1 {
    width: 100%;
    height: 120px;
  }
  .top {
    position: fixed;
    z-index: 99999;
    top: 0;
    left: 0;
    width: 100%;
    height: 120px;
    background: url(../assets/img/top_bgs.jpg) no-repeat;
    background-size: cover;
    .logo {
      width: 222px;
      height: 66px;
      margin-top: 27px;
      margin-left: 10px;
      float: left;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    .indextext {
      display: none;
    }
    .menu {
      display: block;
      float: left;
      width: 50px;
      height: 50px;
      text-align: center;
      margin-top: 35px;
      margin-left: 10px;
      margin-right: 10px;
      .menuicon {
        font-size: 40px;
        color: #13297e;
      }
    }
    .inner1 {
      width: 100%;
      height: 100%;
    }
    .sswarp {
      width: 323px;
      height: 37px;
      box-sizing: border-box;
      float: right;
      overflow: hidden;
      margin-top: 41px;
      .inp {
        width: 265px;
        box-sizing: border-box;
        height: 37px;
        float: left;
        border: 1px solid #b6b6b6;
        font-size: 18px;
        padding: 0px 8px;
      }
      .ss {
        float: left;
        width: 58px;
        text-align: center;
        color: #fff;
        background: #263c92;
        float: left;
        height: 37px;
        line-height: 37px;
        cursor: pointer;
      }
      input:focus {
        box-sizing: border-box;
        outline: none;
      }
    }
    .ggh {
      display: none;
      float: right;
      width: 140px;
      height: 37px;
      overflow: hidden;
      margin-top: 41px;
      margin-left: 60px;
      margin-right: 20px;
      cursor: pointer;
      img {
        width: 30px;
        height: 24px;
        margin-top: 6px;
        float: left;
      }
      span {
        float: left;
        font-size: 16px;
        font-weight: 550;
        line-height: 37px;
        margin-left: 10px;
        color: #282828;
      }
    }
  }
}
.toptab {
  // height: 0px;
  display: none;
  // overflow: hidden;
}
.bottom {
  width: 100%;
  background: #241e1e;
  color: #989493;
  padding-bottom: 15px;
  .leftwarp {
    width: 100%;
    padding: 0 25px;
    box-sizing: border-box;
    overflow: hidden;
    .title {
      width: 100%;
      color: #d9d9d7;
      font-size: 18px;
      margin-top: 0px;
      line-height: 40px;
    }
    .ljwarp {
      width: 100%;
      overflow: hidden;
      .textlist {
        float: left;
        font-size: 14px;
        line-height: 25px;
        width: 50%;
        span {
          cursor: pointer;
          a {
            color: #989493;
          }
        }
      }
    }
  }
  .rightwarp {
    width: 100%;
    padding: 0 25px;
    box-sizing: border-box;
    .title {
      width: 100%;
      color: #d9d9d7;
      font-size: 18px;
      margin-top: 0px;
      line-height: 40px;
    }
    .xxwarp {
      width: 100%;
      overflow: hidden;
      .xxlist {
        width: 100%;
        cursor: pointer;
        font-size: 14px;
        line-height: 25px;
      }
    }
  }
}
.security {
  width: 100%;
  background: #263c92;
  color: #fff;
  padding: 10px;
  box-sizing: border-box;
  .inner {
    text-align: center;
    .btlist {
      // min-width: 51%;
      margin: 0 auto;
      overflow: hidden;
      display: flex;
      justify-content: center;
      line-height: 20px;
      font-size: 12px;
      .bq {
        padding: 0 30px;
        border-right: 1px solid #fff;
        line-height: 16px;
        margin-bottom: 5px;
        font-size: 12px;
      }
      .bq:nth-last-child(1) {
        border: none;
      }
    }
  }
}
.appcd {
  width: 100%;
  overflow: hidden;
  .tk {
    height: calc(100vh - 120px);
    margin-top: 120px;
    box-sizing: border-box;
    .menuwarp {
      width: 100%;
      height: 100%;
      overflow: hidden;
      padding: 0px;
      box-sizing: border-box;
      background: #263c92;
      padding-top: 5px;
      color: #ccc;
      .menuitem {
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding-left: 20px;
        box-sizing: border-box;
        padding-right: 5px;
        color: #ccc;
        .text {
          float: left;
          font-size: 18px;
        }
        .icon {
          float: right;
          line-height: 40px;
        }
      }
      .actionitem {
        color: #fff;
        background: #13297e;
      }
    }
  }
}
</style>
